/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type UpdateSkillPersonInput = {
    personId?: string | null | undefined;
    skillPersons?: Array<SkillPersonInputType | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type SkillPersonInputType = {
    personId?: string | null | undefined;
    skillId?: string | null | undefined;
    skillLevelId?: string | null | undefined;
};
export type updateSkillPersonMutationVariables = {
    input: UpdateSkillPersonInput;
};
export type updateSkillPersonMutationResponse = {
    readonly updateSkillPerson: {
        readonly viewer: {
            readonly " $fragmentRefs": FragmentRefs<"settingsProfileViewer_viewer">;
        } | null;
        readonly person: {
            readonly id: string;
            readonly createdAt: string | null;
            readonly createdBy: string | null;
            readonly harvestUser: boolean | null;
            readonly economicUser: boolean | null;
            readonly initials: string | null;
            readonly gitlabUser: {
                readonly integrationUserId: number | null;
            } | null;
            readonly gitlabServerUser: {
                readonly integrationUserId: number | null;
            } | null;
            readonly githubUser: {
                readonly integrationUserId: number | null;
            } | null;
            readonly jiraServerUser: boolean | null;
            readonly jiraCloudUser: boolean | null;
            readonly asanaUser: boolean | null;
            readonly adoUserId: string | null;
            readonly unit4User: boolean | null;
            readonly msTeamsId: string | null;
            readonly bambooHRId: string | null;
            readonly firstName: string | null;
            readonly lastName: string | null;
            readonly fullName: string | null;
            readonly email: string | null;
            readonly startDate: string | null;
            readonly endDate: string | null;
            readonly profilePictureId: string | null;
            readonly profilePictureDefaultId: number | null;
            readonly role: {
                readonly id: string;
                readonly name: string | null;
            } | null;
            readonly skillPersons: ReadonlyArray<{
                readonly skill: {
                    readonly id: string;
                } | null;
                readonly level: {
                    readonly id: string;
                } | null;
            } | null> | null;
            readonly permissions: ReadonlyArray<string | null> | null;
            readonly active: boolean | null;
            readonly invited: boolean | null;
            readonly isViewer: boolean | null;
            readonly costPeriods: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly id: string;
                        readonly startDay: number | null;
                        readonly startMonth: number | null;
                        readonly startYear: number | null;
                        readonly cost: number | null;
                    } | null;
                } | null> | null;
            } | null;
            readonly department: {
                readonly id: string;
                readonly name: string | null;
            } | null;
        } | null;
    } | null;
};
export type updateSkillPersonMutation = {
    readonly response: updateSkillPersonMutationResponse;
    readonly variables: updateSkillPersonMutationVariables;
};



/*
mutation updateSkillPersonMutation(
  $input: UpdateSkillPersonInput!
) {
  updateSkillPerson(input: $input) {
    viewer {
      ...settingsProfileViewer_viewer
      id
    }
    person {
      id
      createdAt
      createdBy
      harvestUser
      economicUser
      initials
      gitlabUser {
        integrationUserId
      }
      gitlabServerUser {
        integrationUserId
      }
      githubUser {
        integrationUserId
      }
      jiraServerUser
      jiraCloudUser
      asanaUser
      adoUserId
      unit4User
      msTeamsId
      bambooHRId
      firstName
      lastName
      fullName
      email
      startDate
      endDate
      profilePictureId
      profilePictureDefaultId
      role {
        id
        name
      }
      skillPersons {
        skill {
          id
        }
        level {
          id
        }
        id
      }
      permissions
      active
      invited
      isViewer
      costPeriods(first: 10000) {
        edges {
          node {
            id
            startDay
            startMonth
            startYear
            cost
            __typename
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      department {
        id
        name
      }
    }
  }
}

fragment LabelDropdown_labels on Label {
  id
  name
  color
  category {
    id
    name
  }
}

fragment ProfileSkills_company on Company {
  skillLevelsEnabled
  skillLevels {
    id
    level
    description
  }
  skills {
    edges {
      node {
        id
        name
        category {
          name
          id
        }
      }
    }
  }
}

fragment SettingsCalendarWrapper_viewer on Viewer {
  id
  calendarIntegrations {
    id
    googleCalendar {
      id
      calendarTokenError
      calendarViewPrivateEvents
      calendarUser {
        name
        email
        picture
      }
      enabledCalendars
      calendars {
        edges {
          node {
            id
            name
            type
            description
            backgroundColor
            foregroundColor
          }
        }
      }
    }
    outlookCalendar {
      id
      calendarTokenError
      calendarViewPrivateEvents
      calendarUser {
        name
        email
        picture
      }
      enabledCalendars
      calendars {
        edges {
          node {
            id
            name
            type
            description
            backgroundColor
            foregroundColor
          }
        }
      }
    }
  }
}

fragment SettingsProfileSubNav_viewer on Viewer {
  id
  projectOwner
  disableNotifications
  company {
    id
    forecastDemo
    tier
  }
}

fragment settingsProfileViewer_viewer on Viewer {
  availableFeatureFlags {
    key
    id
  }
  id
  language
  profiles(first: 10000) {
    edges {
      node {
        id
        name
        permissions
      }
    }
  }
  permissions
  initials
  personLabels(first: 10000) {
    edges {
      node {
        label {
          id
          name
          color
        }
        id
      }
    }
  }
  skillPersons {
    skill {
      id
    }
    level {
      id
    }
    id
  }
  actualPersonId
  firstName
  lastName
  email
  jobTitle
  department {
    id
    name
  }
  costCenter
  monday
  tuesday
  wednesday
  thursday
  friday
  saturday
  sunday
  startDate
  endDate
  calendarKey
  profilePictureId
  profilePictureDefaultId
  cost
  role {
    id
    name
  }
  client {
    id
  }
  holidayCalendar {
    id
  }
  company {
    id
    name
    currency
    gitlabEnabled
    gitlabServerEnabled
    githubEnabled
    harvestEnabled
    unit4Enabled
    calendarApiEnabled
    outlookCalendarApiEnabled
    jiraCloudEnabled
    jiraServerEnabled
    hiBobEnabled
    hiBobConnectionEnabled
    bambooHREnabled
    newSlackEnabled
    sageIntacctConnectionEnabled
    oktaEnabled
    oneloginEnabled
    AADEnabled
    vstsEnabled
    tier
    weekendDisplayPerUser
    weekendDisplayShowAlways
    modules {
      moduleType
      id
    }
    contactPersons {
      edges {
        node {
          id
          contactType
          person {
            id
            fullName
            email
            phone
          }
        }
      }
    }
    profiles(first: 100000) {
      edges {
        node {
          id
          name
          canBeEdited
          personsCount
          permissions
          disabled
        }
      }
    }
    departments(first: 1000) {
      edges {
        node {
          id
          name
        }
      }
    }
    roles(first: 1000) {
      edges {
        node {
          id
          name
        }
      }
    }
    ...ProfileSkills_company
    labels(first: 10000, labelType: PERSON) {
      edges {
        node {
          id
          name
          color
          category {
            id
            name
          }
          ...LabelDropdown_labels
        }
      }
    }
    holidayCalendars(first: 10000) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
  gitlabUser {
    integrationUserId
  }
  gitlabServerUser {
    integrationUserId
  }
  githubUser {
    integrationUserId
  }
  unit4UserObject
  bambooHRId
  harvestUser
  jiraCloudId
  jiraServerId
  sisenseUserId
  slackId
  sageIntacctId
  sageIntacctName
  sageIntacctEmail
  sageIntacctLocationId
  adoUserId
  ...SettingsProfileSubNav_viewer
  ...SettingsCalendarWrapper_viewer
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateSkillPersonInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdBy",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "harvestUser",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "economicUser",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "initials",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "integrationUserId",
    "storageKey": null
  }
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationUserType",
  "kind": "LinkedField",
  "name": "gitlabUser",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationUserType",
  "kind": "LinkedField",
  "name": "gitlabServerUser",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationUserType",
  "kind": "LinkedField",
  "name": "githubUser",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraServerUser",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraCloudUser",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "asanaUser",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "adoUserId",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit4User",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "msTeamsId",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bambooHRId",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureDefaultId",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v28 = [
  (v2/*: any*/),
  (v27/*: any*/)
],
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v28/*: any*/),
  "storageKey": null
},
v30 = [
  (v2/*: any*/)
],
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "Skill",
  "kind": "LinkedField",
  "name": "skill",
  "plural": false,
  "selections": (v30/*: any*/),
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillLevel",
  "kind": "LinkedField",
  "name": "level",
  "plural": false,
  "selections": (v30/*: any*/),
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "permissions",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invited",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isViewer",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cost",
  "storageKey": null
},
v38 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CostPeriodTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CostPeriod",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startDay",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startYear",
            "storageKey": null
          },
          (v37/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "DepartmentType",
  "kind": "LinkedField",
  "name": "department",
  "plural": false,
  "selections": (v28/*: any*/),
  "storageKey": null
},
v40 = {
  "kind": "Literal",
  "name": "first",
  "value": 10000
},
v41 = [
  (v40/*: any*/)
],
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillPerson",
  "kind": "LinkedField",
  "name": "skillPersons",
  "plural": true,
  "selections": [
    (v31/*: any*/),
    (v32/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v44 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v46 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "calendarTokenError",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "calendarViewPrivateEvents",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CalendarUser",
    "kind": "LinkedField",
    "name": "calendarUser",
    "plural": false,
    "selections": [
      (v27/*: any*/),
      (v22/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "picture",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "enabledCalendars",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CalendarTypeConnection",
    "kind": "LinkedField",
    "name": "calendars",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CalendarTypeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Calendar",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v27/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              (v45/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "backgroundColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "foregroundColor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateSkillPersonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateSkillPersonPayload",
        "kind": "LinkedField",
        "name": "updateSkillPerson",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "settingsProfileViewer_viewer"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v29/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SkillPerson",
                "kind": "LinkedField",
                "name": "skillPersons",
                "plural": true,
                "selections": [
                  (v31/*: any*/),
                  (v32/*: any*/)
                ],
                "storageKey": null
              },
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              {
                "alias": "costPeriods",
                "args": null,
                "concreteType": "CostPeriodTypeConnection",
                "kind": "LinkedField",
                "name": "__Person_costPeriods_connection",
                "plural": false,
                "selections": (v38/*: any*/),
                "storageKey": null
              },
              (v39/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateSkillPersonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateSkillPersonPayload",
        "kind": "LinkedField",
        "name": "updateSkillPerson",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FeatureFlag",
                "kind": "LinkedField",
                "name": "availableFeatureFlags",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "language",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v41/*: any*/),
                "concreteType": "ProfileTypeConnection",
                "kind": "LinkedField",
                "name": "profiles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfileTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Profile",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v27/*: any*/),
                          (v33/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "profiles(first:10000)"
              },
              (v33/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": (v41/*: any*/),
                "concreteType": "PersonLabelTypeConnection",
                "kind": "LinkedField",
                "name": "personLabels",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonLabelTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PersonLabel",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Label",
                            "kind": "LinkedField",
                            "name": "label",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v27/*: any*/),
                              (v42/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "personLabels(first:10000)"
              },
              (v43/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "actualPersonId",
                "storageKey": null
              },
              (v19/*: any*/),
              (v20/*: any*/),
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jobTitle",
                "storageKey": null
              },
              (v39/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "costCenter",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "monday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tuesday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "wednesday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thursday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "friday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "saturday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sunday",
                "storageKey": null
              },
              (v23/*: any*/),
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "calendarKey",
                "storageKey": null
              },
              (v25/*: any*/),
              (v26/*: any*/),
              (v37/*: any*/),
              (v29/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Client",
                "kind": "LinkedField",
                "name": "client",
                "plural": false,
                "selections": (v30/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "HolidayCalendar",
                "kind": "LinkedField",
                "name": "holidayCalendar",
                "plural": false,
                "selections": (v30/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currency",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "gitlabEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "gitlabServerEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "githubEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "harvestEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "unit4Enabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "calendarApiEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "outlookCalendarApiEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jiraCloudEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jiraServerEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hiBobEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hiBobConnectionEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "bambooHREnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "newSlackEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sageIntacctConnectionEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "oktaEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "oneloginEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "AADEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vstsEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tier",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "weekendDisplayPerUser",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "weekendDisplayShowAlways",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Module",
                    "kind": "LinkedField",
                    "name": "modules",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "moduleType",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyContactTypeConnection",
                    "kind": "LinkedField",
                    "name": "contactPersons",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CompanyContactTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CompanyContact",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "contactType",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Person",
                                "kind": "LinkedField",
                                "name": "person",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "phone",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 100000
                      }
                    ],
                    "concreteType": "ProfileTypeConnection",
                    "kind": "LinkedField",
                    "name": "profiles",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Profile",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v27/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "canBeEdited",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "personsCount",
                                "storageKey": null
                              },
                              (v33/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "disabled",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "profiles(first:100000)"
                  },
                  {
                    "alias": null,
                    "args": (v44/*: any*/),
                    "concreteType": "DepartmentTypeConnection",
                    "kind": "LinkedField",
                    "name": "departments",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DepartmentTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DepartmentType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v28/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "departments(first:1000)"
                  },
                  {
                    "alias": null,
                    "args": (v44/*: any*/),
                    "concreteType": "RoleTypeConnection",
                    "kind": "LinkedField",
                    "name": "roles",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoleTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Role",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v28/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "roles(first:1000)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "skillLevelsEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SkillLevel",
                    "kind": "LinkedField",
                    "name": "skillLevels",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "level",
                        "storageKey": null
                      },
                      (v45/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SkillTypeConnection",
                    "kind": "LinkedField",
                    "name": "skills",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SkillTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Skill",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v27/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SkillCategory",
                                "kind": "LinkedField",
                                "name": "category",
                                "plural": false,
                                "selections": [
                                  (v27/*: any*/),
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      (v40/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "labelType",
                        "value": "PERSON"
                      }
                    ],
                    "concreteType": "LabelTypeConnection",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LabelTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Label",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v27/*: any*/),
                              (v42/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LabelCategory",
                                "kind": "LinkedField",
                                "name": "category",
                                "plural": false,
                                "selections": (v28/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "labels(first:10000,labelType:\"PERSON\")"
                  },
                  {
                    "alias": null,
                    "args": (v41/*: any*/),
                    "concreteType": "HolidayCalendarTypeConnection",
                    "kind": "LinkedField",
                    "name": "holidayCalendars",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HolidayCalendarTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "HolidayCalendar",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v28/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "holidayCalendars(first:10000)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastDemo",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unit4UserObject",
                "storageKey": null
              },
              (v18/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jiraCloudId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jiraServerId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sisenseUserId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slackId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctEmail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctLocationId",
                "storageKey": null
              },
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectOwner",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "disableNotifications",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CalendarIntegrations",
                "kind": "LinkedField",
                "name": "calendarIntegrations",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CalendarIntegration",
                    "kind": "LinkedField",
                    "name": "googleCalendar",
                    "plural": false,
                    "selections": (v46/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CalendarIntegration",
                    "kind": "LinkedField",
                    "name": "outlookCalendar",
                    "plural": false,
                    "selections": (v46/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v29/*: any*/),
              (v43/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              {
                "alias": null,
                "args": (v41/*: any*/),
                "concreteType": "CostPeriodTypeConnection",
                "kind": "LinkedField",
                "name": "costPeriods",
                "plural": false,
                "selections": (v38/*: any*/),
                "storageKey": "costPeriods(first:10000)"
              },
              {
                "alias": null,
                "args": (v41/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Person_costPeriods",
                "kind": "LinkedHandle",
                "name": "costPeriods"
              },
              (v39/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "updateSkillPerson",
            "person",
            "costPeriods"
          ]
        }
      ]
    },
    "name": "updateSkillPersonMutation",
    "operationKind": "mutation",
    "text": "mutation updateSkillPersonMutation(\n  $input: UpdateSkillPersonInput!\n) {\n  updateSkillPerson(input: $input) {\n    viewer {\n      ...settingsProfileViewer_viewer\n      id\n    }\n    person {\n      id\n      createdAt\n      createdBy\n      harvestUser\n      economicUser\n      initials\n      gitlabUser {\n        integrationUserId\n      }\n      gitlabServerUser {\n        integrationUserId\n      }\n      githubUser {\n        integrationUserId\n      }\n      jiraServerUser\n      jiraCloudUser\n      asanaUser\n      adoUserId\n      unit4User\n      msTeamsId\n      bambooHRId\n      firstName\n      lastName\n      fullName\n      email\n      startDate\n      endDate\n      profilePictureId\n      profilePictureDefaultId\n      role {\n        id\n        name\n      }\n      skillPersons {\n        skill {\n          id\n        }\n        level {\n          id\n        }\n        id\n      }\n      permissions\n      active\n      invited\n      isViewer\n      costPeriods(first: 10000) {\n        edges {\n          node {\n            id\n            startDay\n            startMonth\n            startYear\n            cost\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      department {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment LabelDropdown_labels on Label {\n  id\n  name\n  color\n  category {\n    id\n    name\n  }\n}\n\nfragment ProfileSkills_company on Company {\n  skillLevelsEnabled\n  skillLevels {\n    id\n    level\n    description\n  }\n  skills {\n    edges {\n      node {\n        id\n        name\n        category {\n          name\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment SettingsCalendarWrapper_viewer on Viewer {\n  id\n  calendarIntegrations {\n    id\n    googleCalendar {\n      id\n      calendarTokenError\n      calendarViewPrivateEvents\n      calendarUser {\n        name\n        email\n        picture\n      }\n      enabledCalendars\n      calendars {\n        edges {\n          node {\n            id\n            name\n            type\n            description\n            backgroundColor\n            foregroundColor\n          }\n        }\n      }\n    }\n    outlookCalendar {\n      id\n      calendarTokenError\n      calendarViewPrivateEvents\n      calendarUser {\n        name\n        email\n        picture\n      }\n      enabledCalendars\n      calendars {\n        edges {\n          node {\n            id\n            name\n            type\n            description\n            backgroundColor\n            foregroundColor\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment SettingsProfileSubNav_viewer on Viewer {\n  id\n  projectOwner\n  disableNotifications\n  company {\n    id\n    forecastDemo\n    tier\n  }\n}\n\nfragment settingsProfileViewer_viewer on Viewer {\n  availableFeatureFlags {\n    key\n    id\n  }\n  id\n  language\n  profiles(first: 10000) {\n    edges {\n      node {\n        id\n        name\n        permissions\n      }\n    }\n  }\n  permissions\n  initials\n  personLabels(first: 10000) {\n    edges {\n      node {\n        label {\n          id\n          name\n          color\n        }\n        id\n      }\n    }\n  }\n  skillPersons {\n    skill {\n      id\n    }\n    level {\n      id\n    }\n    id\n  }\n  actualPersonId\n  firstName\n  lastName\n  email\n  jobTitle\n  department {\n    id\n    name\n  }\n  costCenter\n  monday\n  tuesday\n  wednesday\n  thursday\n  friday\n  saturday\n  sunday\n  startDate\n  endDate\n  calendarKey\n  profilePictureId\n  profilePictureDefaultId\n  cost\n  role {\n    id\n    name\n  }\n  client {\n    id\n  }\n  holidayCalendar {\n    id\n  }\n  company {\n    id\n    name\n    currency\n    gitlabEnabled\n    gitlabServerEnabled\n    githubEnabled\n    harvestEnabled\n    unit4Enabled\n    calendarApiEnabled\n    outlookCalendarApiEnabled\n    jiraCloudEnabled\n    jiraServerEnabled\n    hiBobEnabled\n    hiBobConnectionEnabled\n    bambooHREnabled\n    newSlackEnabled\n    sageIntacctConnectionEnabled\n    oktaEnabled\n    oneloginEnabled\n    AADEnabled\n    vstsEnabled\n    tier\n    weekendDisplayPerUser\n    weekendDisplayShowAlways\n    modules {\n      moduleType\n      id\n    }\n    contactPersons {\n      edges {\n        node {\n          id\n          contactType\n          person {\n            id\n            fullName\n            email\n            phone\n          }\n        }\n      }\n    }\n    profiles(first: 100000) {\n      edges {\n        node {\n          id\n          name\n          canBeEdited\n          personsCount\n          permissions\n          disabled\n        }\n      }\n    }\n    departments(first: 1000) {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n    roles(first: 1000) {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n    ...ProfileSkills_company\n    labels(first: 10000, labelType: PERSON) {\n      edges {\n        node {\n          id\n          name\n          color\n          category {\n            id\n            name\n          }\n          ...LabelDropdown_labels\n        }\n      }\n    }\n    holidayCalendars(first: 10000) {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n  }\n  gitlabUser {\n    integrationUserId\n  }\n  gitlabServerUser {\n    integrationUserId\n  }\n  githubUser {\n    integrationUserId\n  }\n  unit4UserObject\n  bambooHRId\n  harvestUser\n  jiraCloudId\n  jiraServerId\n  sisenseUserId\n  slackId\n  sageIntacctId\n  sageIntacctName\n  sageIntacctEmail\n  sageIntacctLocationId\n  adoUserId\n  ...SettingsProfileSubNav_viewer\n  ...SettingsCalendarWrapper_viewer\n}\n"
  }
};
})();
(node as any).hash = '27934aaeee1486b7ac434534d7d47107';
export default node;
